import { IconButton, TextField } from "@mui/material";
import { Close, Search } from "@mui/icons-material";

export function SearchToolbar({ search, setSearch }) {
    const isSearching = search.length > 0;

    return (
        <TextField
            onChange={(event) => setSearch(event.target.value)}
            value={search}
            label="Search..."
            sx={{
                height: '100%',
                paddingRight: '0.5rem',
                '& .MuiInputBase-root': {
                    height: '100%',
                    boxSizing: 'border-box',
                },
                '& .MuiInputBase-input': {
                    padding: '0.5em',
                    height: '100%',
                },
                '& .MuiInputLabel-root': {
                    fontSize: '0.85rem',
                },
            }}
            size="small"
            slotProps={{
                input: {
                    endAdornment: isSearching ? (
                        <IconButton onClick={() => setSearch("")} edge="end" size="small">
                            <Close />
                        </IconButton>
                    ) : (
                        <Search sx={{ opacity: 0.5, marginRight: "0.5em" }} />
                    ),
                },
            }}
        />
    );
}
